/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormTextareaField, {
  FormTextareaFieldProps
} from '../../../../client/js/components/form/fields/FormTextareaField'

function DescriptionField (props: FormTextareaFieldProps) {
  const { name = 'description', ...others } = props
  const intl = useIntl()
  return (
    <FormTextareaField
      label={intl.formatMessage({
        id: 'description',
        defaultMessage: 'Description'
      })}
      name={name}
      parser={upperFirst}
      rows={5}
      {...others}
    />
  )
}

export default DescriptionField
